export default __webpack_public_path__ + "static/media/poster_02_march_desktop.d5059250.png";